export const metaTagConstants = {
    META_LIST_PENDING: 'META_LIST_PENDING',
    META_LIST_FULFILLED: 'META_LIST_FULFILLED',
    META_LIST_REJECTED: 'META_LIST_REJECTED',

    META_TAG_LIST_PENDING: 'META_TAG_LIST_PENDING',
    META_TAG_LIST_FULFILLED: 'META_TAG_LIST_FULFILLED',
    META_TAG_LIST_REJECTED: 'META_TAG_LIST_REJECTED',

    META_TAG_MAPPING_PENDING: 'META_TAG_MAPPING_PENDING',
    META_TAG_MAPPING_FULFILLED: 'META_TAG_MAPPING_FULFILLED',
    META_TAG_MAPPING_REJECTED: 'META_TAG_MAPPING_REJECTED',

    META_TAG_SYNC_PENDING: 'META_TAG_SYNC_PENDING',
    META_TAG_SYNC_FULFILLED: 'META_TAG_SYNC_FULFILLED',
    META_TAG_SYNC_REJECTED: 'META_TAG_SYNC_REJECTED',
    META_TAG_SYNC_CLEAR: 'META_TAG_SYNC_CLEAR',
};
